export type WorkflowSystemId = 'trr-jira-workflow' | 'trr-servicenow-workflow'

export const WORKFLOW_SYSTEM_NAMES: Record<WorkflowSystemId, string> = {
  'trr-jira-workflow': 'Jira',
  'trr-servicenow-workflow': 'ServiceNow',
}
